module.exports = __webpack_public_path__ + "fonts/Sarabun-Thin.d00bfab5.ttf";